import { CssBaseline } from '@mui/material'
import { RainbowKitProvider, darkTheme } from '@rainbow-me/rainbowkit'
import '@rainbow-me/rainbowkit/styles.css'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { WagmiProvider } from 'wagmi'
import App from './App'
import { config } from './components'
import './index.css'
import reportWebVitals from './reportWebVitals'
import { customPaletteColors } from './themes/common'
import useGlobalStore from './stores/global'


const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
const queryClient = new QueryClient()

const Providers = () => {
  const chainId = useGlobalStore((s) => s.initialChainId)

  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        {/* key forces remount so RainbowKit reads new initialChain */}
        <RainbowKitProvider
          key={`rk-${chainId}`}
          theme={darkTheme({
            accentColor: customPaletteColors.brand.primary,
            accentColorForeground: customPaletteColors.brand.charcoal,
            borderRadius: 'medium',
          })}
          initialChain={chainId}  // pass an id (number) for safety
        >
          <App />
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  )
}

root.render(
  <React.StrictMode>
    <CssBaseline />
    <Providers />
  </React.StrictMode>,
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
